import React, { useState } from "react";

// COMPONENTS
import KogModalFadeComponent from "@/main/components/modal/ModalFadeComponent";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import Button from "@/main/components/shared/button/button";

// UTILS/SERVICES/MODELS
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";

// STYLES & COMPONENTS LOCAL
import * as S from "./styles";

interface IModalConfirmRequoteOrderedPartProps {
	openModalConfirm: boolean;
	setOpenModalConfirm: React.Dispatch<React.SetStateAction<boolean>>;
	onClickActionConfirm: () => void;
	callbackAfterRequotePart?: () => void;
}
function ModalConfirmRequoteOrderedPart({
	setOpenModalConfirm,
	onClickActionConfirm,
	callbackAfterRequotePart,
}: IModalConfirmRequoteOrderedPartProps) {
	const [isLoadingSave, setIsLoadingSave] = useState<boolean>(false);

	async function handleOnClickActionConfirm() {
		try {
			setIsLoadingSave(true);
			await onClickActionConfirm();
		} catch (error) {
			console.error(error);
		} finally {
			setIsLoadingSave(false);
			if (!isNullUndefined(callbackAfterRequotePart)) {
				callbackAfterRequotePart();
			}
		}
	}

	return (
		<S.ContainerModalConfirmation>
			<p>{getTranslateByKey("information.confirmRequoteOrdered")}</p>
			<p>{getTranslateByKey("information.thisActionIsIrreversible")}</p>
			<S.AreaButtons>
				<SecondaryButton
					type="button"
					disabled={isLoadingSave}
					onClick={() => {
						setOpenModalConfirm(false);
					}}
					id="id-searchOrder-button-no"
				>
					{getTranslateByKey("information.no")}
				</SecondaryButton>
				<Button
					id="id-searchOrder-button-yes"
					type="button"
					isLoading={isLoadingSave}
					onClick={() => handleOnClickActionConfirm()}
				>
					{getTranslateByKey("information.yes")}
				</Button>
			</S.AreaButtons>
		</S.ContainerModalConfirmation>
	);
}
function WrapperModalConfirmRequoteOrdered(props: IModalConfirmRequoteOrderedPartProps) {
	return (
		<KogModalFadeComponent isInModal open={props.openModalConfirm} setOpen={props.setOpenModalConfirm}>
			{props.openModalConfirm ? <ModalConfirmRequoteOrderedPart {...props} /> : <div />}
		</KogModalFadeComponent>
	);
}
export default WrapperModalConfirmRequoteOrdered;
